<template>
  <app-side-menu 
    :min-width="18"
    :fixed-menu="false">
    <aside 
      class="menu"
      slot="side-menu">
      <!-- <p class="menu-label">
        <span class="title is-6">
          {{entityName}}
        </span>
      </p> -->
      <ul class="menu-list">
        <li>
          <router-link 
            :to="{ name: routeTypes.EmailSmsLogDetail.name, query: $route.query }"
            active-class="is-active" 
            exact>
            Detail Info
          </router-link>
        </li>
      </ul>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import EmailSmsLogRoutes from './route-types'

export default {
  name: 'EmailsmslogSideMenu',
  inject: ['$vv'],
  components: {
    AppSideMenu
  },
  props: {
    entityName: {
      type: String,
      default: ''
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    routeTypes() {
      return EmailSmsLogRoutes
    }
  },
  methods: {}
}
</script>
